<template>
    <section class="container">
        <side-menu/>
        <div class="care-plans">
            <div v-if="carePlans && carePlans.documents.length > 0">
                <div class="card" v-for="document in carePlans.documents">
                    <div class="wrapper">
                        <h2>Plano de cuidado {{getDate(document.created_at)}}</h2>
                        <p>{{carePlans.doctor.name}}</p>
                        <div class="text">
                            <p><strong>Resultado dos exames:</strong> {{carePlans.result_exams}}</p>
                            <p><strong>Orientações de saúde:</strong> {{carePlans.health_orientation}}</p>
                            <p><strong>Encaminhamentos/Medicações:</strong> {{carePlans.forwarding_medication}}</p>
                        </div>
                    </div>
                    <a class="action" target="blank" :href="document.url">
                        <span>Acessar Plano &nbsp; </span><font-awesome-icon class="icon" :icon="['fa', 'external-link-alt']"/>
                    </a>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    import {GET_CUSTOMER} from "../../services/customer";

    import {library} from '@fortawesome/fontawesome-svg-core'
    import {
        faExternalLinkAlt,
        faFileAlt
    } from '@fortawesome/free-solid-svg-icons'

    library.add(faExternalLinkAlt);
    library.add(faFileAlt);

    export default {
        name: "care-plan",
        props: {
            result: Object,
        },
        data() {
            return {
                carePlans: null
            };
        },
        methods: {
            back() {
                this.$emit('back');
            },
            getDate(date) {
                date = new Date(date);
                date = (this.aditionalZero(date.getDate())) + "/" + ((this.aditionalZero(date.getMonth() + 1))) + "/" + date.getFullYear();
                return date;
            },
            aditionalZero(number) {
                return (number <= 9) ? "0" + number : number;
            },
        },
        async mounted() {
            const resp = await GET_CUSTOMER();
            this.carePlans = resp.customer.care_plan;
        },
    }
</script>
<style scoped>
  @import "./care-plan.scss";
  @import "./responsive.css";
</style>



// WEBPACK FOOTER //
// src/components/CarePlan/CarePlan.vue